<script lang="ts" setup>
import Icon from '@ant-design/icons-vue';
</script>
<template>
  <Icon>
    <template #component>
      <svg
        width="28"
        height="28"
        viewBox="0 0 28 28"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="14" cy="14" r="14" fill="white" />
        <path
          d="M12 10L16 14L12 18"
          stroke="black"
          stroke-opacity="0.85"
          stroke-width="2"
          stroke-linecap="round"
        />
      </svg>
    </template>
  </Icon>
</template>
